// extracted by mini-css-extract-plugin
export default {"frame":"style_frame__pjczb","sliderWrapper":"style_sliderWrapper__tLNht","imgs":"style_imgs__Uoz7z"};